import api from "client/utils/clientApiHelper";
import { apiMethod, apiType, API_URL } from "utils";


const getSubscriptionTypes = () => {
  let payloadData = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Notification,
    endpoint: 'notification/subscriptionType',
  }
  return api.callNotificationPost(API_URL.PostWebApp, payloadData);
}

const getLookups = () => {
  let payloadData = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Notification,
    endpoint: 'notification/lookups',
  }
  return api.callNotificationPost(API_URL.PostWebApp, payloadData);
}

const getMessageTypes = () =>{
  let payloadData = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Notification,
    endpoint: 'notification/messageTypes',
  }
  return api.callNotificationPost(API_URL.PostWebApp, payloadData);
}

const getNotificationSubscription = (userId: any) =>{
  let payloadData = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Notification,
    endpoint: `notification/getNotificationSubscription?userId=${userId}`,
  }
  return api.callNotificationPost(API_URL.PostWebApp, payloadData);
}  

export default {
  getSubscriptionTypes,
  getLookups,
  getMessageTypes,
  getNotificationSubscription,
};
